/** HarmanaGEL Admin — ortak API ayarları */

export const API_BASE =
  process.env.REACT_APP_API_URL || "https://harmanappapi.stechomeyazilim.info";

export const getAuthHeaders = (extra = {}) => {
  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
  const token = localStorage.getItem("token") || authUser?.Token;
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...extra,
  };
};

export const isAdminUser = () => {
  try {
    const u = JSON.parse(localStorage.getItem("authUser") || "{}");
    const hesap = (u?.HESAP_TURU || "").trim().toLowerCase();
    const yetki = (u?.YETKI_GRUBU || "").trim().toLowerCase();
    return hesap === "admin" || yetki === "admin";
  } catch {
    return false;
  }
};

/** Finans / kullanıcı ban gibi hassas işlemler yalnızca Admin */
export const canManageFinance = () => isAdminUser();

/** İçerik moderasyonu: Admin veya Moderatör */
export const canModerate = () => {
  try {
    const u = JSON.parse(localStorage.getItem("authUser") || "{}");
    const hesap = (u?.HESAP_TURU || "").trim().toLowerCase();
    const yetki = (u?.YETKI_GRUBU || "").trim().toLowerCase();
    return hesap === "admin" || yetki === "admin" || yetki === "moderatör" || yetki === "moderator";
  } catch {
    return false;
  }
};

export async function apiJson(path, options = {}) {
  const url = path.startsWith("http") ? path : `${API_BASE}${path}`;
  const res = await fetch(url, {
    ...options,
    headers: {
      ...getAuthHeaders(),
      ...(options.headers || {}),
    },
  });
  const text = await res.text();
  let data = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = text;
  }
  if (!res.ok) {
    const msg =
      (data && (data.message || data.Message || data.error_description)) ||
      (typeof data === "string" ? data : null) ||
      `HTTP ${res.status}`;
    const err = new Error(msg);
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}
